var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-map-tool-item",class:{ 'o-map-tool-item--active': _vm.active },on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click', $event)}}},[_vm._t("default",function(){return [_c('o-icon',{attrs:{"name":_vm.iconName}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }